<template>
  <div id="error">
    <dd-header
      :isMenuView='false'
    />
    <main>
      <div class="wrapper">
        <div v-for="(message, index) in errorMessages" :key="'error-' + index">{{message}}</div>
        <div class="toplink"><a @click="toTop()">トップ画面へ戻る</a></div>
      </div>
    </main>
    <dd-footer />
  </div>
</template>

<script>
import axios from 'axios'
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

export default {
  name: 'Error',
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
      errorMessages: ['システムエラーが発生しました。', 'しばらく時間をおいてから、再度操作してください。']
    }
  },
  methods: {
    toTop: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    logout: function () {
      axios.post(DC_URL.TOP + '/logout', {}
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.USER_INFO)
          App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
          App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
          App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  created () {
    if (this.$route.params.errorMessages) {
      this.errorMessages = this.$route.params.errorMessages
    }
    this.logout()
  }
}
</script>
<style lang="scss" scoped>
#error {
  height: 100%;
}
main {
  height: 100%;
  text-align: center;
  color: #ff4500;
  font-weight: bold;
  word-wrap: break-word;
  line-height: 25px;
  padding: 0;
  overflow: auto;
  .toplink {
    margin-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcError.vue